import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';

const ContentHeader = ({ selectedBet, firstRaceItem, betTypeText }) => {
  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);
  return (
    <div className="game-info">
      <div className="game-info__item">
        { programType === PROGRAM_TYPES.JOINT ? betTypeText || '-' : 'Sabit İhtimalli' }
      </div>
      { programType === PROGRAM_TYPES.JOINT && (
        <>
          <div className="game-info__separator"/>
          <div className="game-info__item">
            { `Oyun Saati: ${firstRaceItem?.legNo}.Koşu (${firstRaceItem?.startTime})` }
          </div>
        </>
      ) }
    </div>
  );
};

ContentHeader.propTypes = {
  selectedBet: PropTypes.object,
  firstRaceItem: PropTypes.object,
  betTypeText: PropTypes.string,
};

export default ContentHeader;
